export function imagePath(assetName : string) {
    return `${process.env.PUBLIC_URL}/assets/images/${assetName}`;
}
